import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlinePricing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      stroke="#BBCAE2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M2.958 15.265v2.308M2.958 5.265V.65M3.727 5.265H2.188c-.85 0-1.538.69-1.538 1.539v6.923c0 .85.689 1.538 1.538 1.538h1.539c.85 0 1.538-.688 1.538-1.538V6.804c0-.85-.688-1.539-1.538-1.539M12.188 11.42H10.65c-.85 0-1.539.688-1.539 1.538v2.307c0 .85.69 1.539 1.539 1.539h1.538c.85 0 1.539-.689 1.539-1.539v-2.307c0-.85-.689-1.539-1.539-1.539M11.42 16.804v3.846M11.42 11.42V6.034M20.555 3.428a1.66 1.66 0 0 0-1.572-1.111h-1.29a1.488 1.488 0 0 0-.318 2.94l1.965.43a1.667 1.667 0 0 1-.357 3.296h-1.11a1.67 1.67 0 0 1-1.573-1.11M18.428 2.317V.65M18.428 10.65V8.983"
    />
  </svg>
);
export default SvgStreamlinePricing;
